import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_APP016_Request,
  IAPI_APP016_Response,
  IAPI_INQ012_Request,
  IAPI_INQ012_Response,
  IAPI_INQ013_Request,
  IAPI_INQ013_Response
} from "../../../type/apiType";

// 申請状況更新
const httpAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

// 職員照会問い合わせ参照
const httpAPI_INQ013 = async (
  param: IAPI_INQ013_Request
): Promise<IAPI_INQ013_Response> => {
  let res = await http.post(ApiUrl.API_INQ013, {
    ...param,
  });

  return res.data;
};
// 職員照会問い合わせ更新
const httpAPI_INQ012 = async (
  param: IAPI_INQ012_Request
): Promise<IAPI_INQ012_Response> => {
  let res = await http.post(ApiUrl.API_INQ012, {
    ...param,
  });

  return res.data;
};

export { httpAPI_APP016, httpAPI_INQ012, httpAPI_INQ013 };

